"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetColorTypes = void 0;

var _type = require("./type");

// eslint-disable-next-line import/prefer-default-export
var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
exports.PresetColorTypes = PresetColorTypes;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/_util/colors.js
// module id = 272
// module chunks = 0